/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetBasicBbsContentPageListRespVo } from './PageDataGetBasicBbsContentPageListRespVo';
import {
    PageDataGetBasicBbsContentPageListRespVoFromJSON,
    PageDataGetBasicBbsContentPageListRespVoFromJSONTyped,
    PageDataGetBasicBbsContentPageListRespVoToJSON,
    PageDataGetBasicBbsContentPageListRespVoToJSONTyped,
} from './PageDataGetBasicBbsContentPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetBasicBbsContentPageListRespVo
 */
export interface ResponsePageDataGetBasicBbsContentPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetBasicBbsContentPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetBasicBbsContentPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetBasicBbsContentPageListRespVo}
     * @memberof ResponsePageDataGetBasicBbsContentPageListRespVo
     */
    data?: PageDataGetBasicBbsContentPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetBasicBbsContentPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetBasicBbsContentPageListRespVo(value: object): value is ResponsePageDataGetBasicBbsContentPageListRespVo {
    return true;
}

export function ResponsePageDataGetBasicBbsContentPageListRespVoFromJSON(json: any): ResponsePageDataGetBasicBbsContentPageListRespVo {
    return ResponsePageDataGetBasicBbsContentPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetBasicBbsContentPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetBasicBbsContentPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetBasicBbsContentPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetBasicBbsContentPageListRespVoToJSON(json: any): ResponsePageDataGetBasicBbsContentPageListRespVo {
    return ResponsePageDataGetBasicBbsContentPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetBasicBbsContentPageListRespVoToJSONTyped(value?: ResponsePageDataGetBasicBbsContentPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetBasicBbsContentPageListRespVoToJSON(value['data']),
    };
}

